import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'spaceVibe'

const OPTIONS = [
  {
    value: 'Calm & relaxing',
    translationKey: 'pages.onboarding.spaceVibe.options.calm',
    subtextKey: 'pages.onboarding.spaceVibe.subtexts.calm',
    emoji: '🧘',
  },
  {
    value: 'Creative & inspiring',
    translationKey: 'pages.onboarding.spaceVibe.options.creative',
    subtextKey: 'pages.onboarding.spaceVibe.subtexts.creative',
    emoji: '🎨',
  },
  {
    value: 'Modern & stylish',
    translationKey: 'pages.onboarding.spaceVibe.options.modern',
    subtextKey: 'pages.onboarding.spaceVibe.subtexts.modern',
    emoji: '✨',
  },
  {
    value: 'Cozy & welcoming',
    translationKey: 'pages.onboarding.spaceVibe.options.cozy',
    subtextKey: 'pages.onboarding.spaceVibe.subtexts.cozy',
    emoji: '🛋️',
  },
  {
    value: 'Just experimenting',
    translationKey: 'pages.onboarding.spaceVibe.options.experimenting',
    subtextKey: 'pages.onboarding.spaceVibe.subtexts.experimenting',
    emoji: '🔍',
  },
]

export default function SpaceVibePage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'What do you want your space to feel like?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  // Transform options to the format expected by QuestionPage
  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    subtext: t(option.subtextKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.spaceVibe.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
